export { default as background } from "./background.png";
export { default as icon } from "./icon.png";
